export default "__VITE_ASSET__G7X_2QwT__"